import { useContext, useEffect, useState } from "react"

import useFetch from "../useFetch"
import { LoaderContext } from "src/context/loaderContext"

import { PatientLookupAPIRes } from "./types"
import { APIEndpoints } from "src/types/apiTypes"




const usePatientLookupCall = (updatePatientPrevCaseDate: (prevDate: string) => void, setDuplicateModalVisibility: (modalVisible: boolean) => void, caseDataSubmission: () => void) => {
  const { setLoader, hideLoader } = useContext(LoaderContext)
  const [totalRefills, updateTotalRefills] = useState<number>(0)




  const { data: lookupPatientData, error: lookupPatientErr, mutate: lookupForPatientName } = 
    useFetch<PatientLookupAPIRes>(APIEndpoints.LOOKUP_PAITENT_WITH_NAME)

  useEffect(() => {
    if (lookupPatientData || lookupPatientErr) {
      hideLoader()
      if (lookupPatientData) {
        const { status, case_data } = lookupPatientData
        if (status) {
          updatePatientPrevCaseDate(case_data[1])
          setDuplicateModalVisibility(true)
          updateTotalRefills(case_data[2])
        }
        else
          caseDataSubmission()
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookupPatientData, lookupPatientErr])

  const patientLookupCall = (firstName: string, lastName: string, middleName: string = "") => {
    if (firstName.length > 0 && lastName.length > 0) {
      setLoader()
      const patientFullName = `${firstName}${middleName.length > 0 ? ` ${middleName}` : ""} ${lastName}`
      lookupForPatientName({}, {}, { patient_fullname: patientFullName })
    }
  }



  return { lookupForPatientName: patientLookupCall, totalRefills }
}

export default usePatientLookupCall
